import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "Do I need trading experience to join?",
        a: "No. MTL is suitable for both beginners and traders who want to improve their understanding. We start from the basics and build up to more advanced market structure step by step.",
    },
    {
        q: "Will I receive signals every day?",
        a: "Yes — members receive regular trading ideas and market updates throughout the week, usually 5 to 15 premium signals daily depending on market conditions.",
    },
    {
        q: "How much time do I need daily?",
        a: "Many of our members are working adults. You can learn and participate according to your own schedule. Live sessions are also recorded so you can catch up anytime.",
    },
    {
        q: "Is this only for Malaysia?",
        a: "No. MTL welcomes traders from Malaysia, Singapore, and other regions. Our content is in English with the occasional Bahasa flavour for our local members.",
    },
    {
        q: "Will I learn how to analyse the market myself?",
        a: "Yes. Education is a core pillar of MTL — we want you to eventually trade with confidence on your own, not depend on signals forever.",
    },
];

const FAQSection = () => {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="bg-white py-20 md:py-28"
        >
            <div className="px-6 md:px-12 lg:px-24">
                <div className="max-w-3xl mx-auto text-center">
                    <span className="inline-block text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#0077b6]">
                        Frequently Asked
                    </span>
                    <h2
                        data-testid="faq-heading"
                        className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-black"
                    >
                        Questions, answered.
                    </h2>
                </div>

                <div className="mt-12 max-w-3xl mx-auto">
                    <Accordion
                        type="single"
                        collapsible
                        className="w-full space-y-3"
                        data-testid="faq-accordion"
                    >
                        {faqs.map((item, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="rounded-2xl border border-gray-200 bg-[#F2F2F2] px-5 sm:px-7 overflow-hidden"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-trigger-${i}`}
                                    className="font-display text-left text-base sm:text-lg font-semibold text-black hover:no-underline py-5"
                                >
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-sm sm:text-base text-gray-600 leading-relaxed pb-6">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
